<template>
  <div class="section-title-component has-text-centered-touch">
    <h3
      class="title is-size-3-widescreen is-size-4-desktop is-size-4-touch has-padding-bottom-10"
    >
      <span class="has-text-info has-padding-right-15">#</span>{{ title }}
    </h3>
    <p class="subtitle is-size-6-mobile">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "SectionTitleComponent",
  props: {
    title: String,
    subtitle: String
  }
};
</script>

<style></style>
